export const LAYOUT_HEADER_ID = 'layout-header';
